import { VesselClfPopupNotification } from "../services/types/vessel-notifications-services.types";


export abstract class VesselClfPopupModelBase extends EventTarget
{
    abstract createVesselClfPopupNotification(data: VesselClfPopupNotification, type: string): Promise<void>;
    abstract setPopupVisibility( type: string, scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, correlationId?: string): void;
    abstract onCancelClicked(): void;
    abstract setWRUpdatePopupVisibility(scheduleId?: string): void;
}

let VesselClfPopupModel: VesselClfPopupModelBase|null = null;

function setVesselClfPopupModel(model: VesselClfPopupModelBase)
{
    VesselClfPopupModel = model;
}

export { VesselClfPopupModel, setVesselClfPopupModel };
